import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const SkeletonUpdateDetails = () => {
  return (
    <>
      {/* Breadcrumb Skeleton */}
      <div className="section_breadcrumb">
        <div className="container placeholder-glow">
          <span className="placeholder col-3 me-2"></span>
          <span className="placeholder col-2"></span>
        </div>
      </div>

      {/* Update Details Skeleton */}
      <section className="update_details_Page update_top_image">
        <div className="container">

          {/* Event Type */}
          <div className="mb-2 placeholder-glow">
            <span className="placeholder col-2" style={{ height: "18px" }}></span>
          </div>

          {/* Date */}
          <div className="mb-3 placeholder-glow">
            <span className="placeholder col-3" style={{ height: "14px" }}></span>
          </div>

          {/* Title */}
          <div className="mb-4 placeholder-glow">
            <span
              className="placeholder col-8 d-block mb-2"
              style={{ height: "32px", borderRadius: "6px" }}
            ></span>
            <span
              className="placeholder col-6 d-block"
              style={{ height: "32px", borderRadius: "6px" }}
            ></span>
          </div>

          {/* Social Icons */}
          <div className="d-flex gap-2 mb-4 placeholder-glow">
            {[1, 2, 3, 4].map((i) => (
              <span
                key={i}
                className="placeholder rounded-circle"
                style={{ width: "36px", height: "36px" }}
              ></span>
            ))}
          </div>

          {/* Banner Image */}
          <div className="mb-4 placeholder-glow">
            <span
              className="placeholder col-12 d-block rounded"
              style={{ height: "320px" }}
            ></span>
          </div>

          {/* Content Paragraphs */}
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="mb-2 placeholder-glow">
              <span className="placeholder col-12"></span>
            </div>
          ))}
          <div className="mb-4 placeholder-glow">
            <span className="placeholder col-8"></span>
          </div>

          {/* Share Text */}
          <div className="mb-3 placeholder-glow">
            <span className="placeholder col-3"></span>
          </div>

          {/* Social Icons Bottom */}
          <div className="d-flex gap-2 placeholder-glow">
            {[1, 2, 3, 4].map((i) => (
              <span
                key={i}
                className="placeholder rounded-circle"
                style={{ width: "36px", height: "36px" }}
              ></span>
            ))}
          </div>

        </div>
      </section>

      {/* Bottom CTA Skeleton */}
      <section className="bottom_green text-center">
        <div className="container">

          <div className="mb-3 placeholder-glow">
            <span
              className="placeholder col-6 d-block mx-auto mb-2"
              style={{ height: "28px" }}
            ></span>
            <span
              className="placeholder col-5 d-block mx-auto"
              style={{ height: "28px" }}
            ></span>
          </div>

          <div className="mb-4 placeholder-glow">
            <span className="placeholder col-4 mx-auto d-block"></span>
          </div>

          <div className="placeholder-glow">
            <span
              className="placeholder col-3 d-block mx-auto rounded"
              style={{ height: "44px" }}
            ></span>
          </div>

        </div>
      </section>
    </>
  );
};

export default SkeletonUpdateDetails;
